import {useEffect, useState} from 'react'
import {FileText} from 'lucide-react'
import {Fechamento, loadFechamentoImage} from './fechamentosApi'

export default function FechamentoCover({closing}: {closing: Fechamento}) {
  const [url, setUrl] = useState('')
  useEffect(() => {
    const controller = new AbortController()
    let objectUrl: string
    loadFechamentoImage(closing.id, 1, true, controller.signal)
      .then((blob) => {
        if (controller.signal.aborted) return
        objectUrl = URL.createObjectURL(blob)
        setUrl(objectUrl)
      })
      .catch(() => {})
    return () => {
      controller.abort()
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [closing.id])
  return url ? (
    <img src={url} alt={'Capa de ' + closing.title} />
  ) : (
    <FileText size={48} aria-hidden='true' />
  )
}
